// OPEN INTERCOM

document.getElementById("open-intercom").addEventListener("click", function () {
  Intercom("showNewMessage");
});

const autoFormApp = {
  init() {
    this.url = window.location.href;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    this.formId = params.form;
    if (!params || !this.formId) return;
    this.selectForm();
  },

  selectForm() {
    const element = document.getElementById(this.formId);
    const button = document.querySelector(`[data-id="${this.formId}"]`);
    setTimeout(() => {
      element.classList.add("active");
      button.classList.add("active");
    }, 1000);
  },
};

const resizeObserverApp = {
  init() {
    this.resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        console.log("Height Alterations Recorded!");
        if (entry.contentRect.height > 100 && entry.contentRect.height < 300) {
          const el = document.querySelector(".contact_hulk_forms_sec");
          tabsApp.formsWrap.style.minHeight = entry.contentRect.height + "px";
          if (window.pageYOffset > 50) {
            setTimeout(() => window.scroll(0, 0), 750);
            resizeObserver.unobserve(entry.target);
          }
        }
      });
    });
  },
};

const tabsApp = {
  init() {
    this.tabsWrapper = document.querySelector(".wrapper");
    this.tabButtons = document.querySelectorAll(".enhanced-contact__trigger");
    this.formsWrap = document.querySelector(".enhanced-contact__forms");
    this.contents = document.querySelectorAll(".enhanced-contact__form");
    this.iteration = 0;
    this.setupEventListeners();
  },

  setupEventListeners() {
    this.tabButtons.forEach(
      (btn) => (btn.onclick = this.handleTabButtonClick.bind(this, btn))
    );
    this.contents.forEach((content) =>
      resizeObserverApp.resizeObserver.observe(content)
    );
  },

  handleTabButtonClick(btn) {
    const id = btn.dataset.id;
    if (!id) return;

    this.iteration++;
    const currentElement = document.querySelector(
      ".enhanced-contact__form.active"
    );
    const element = document.getElementById(id);

    if (this.iteration === 2) {
      this.formsWrap.style.minHeight = this.formsWrap.offsetHeight + "px";
    }

    this.tabButtons.forEach((btn) => btn.classList.remove("active"));
    btn.classList.add("active");
    this.contents.forEach((content) => content.classList.remove("active"));
    element.classList.add("active");
  },
};

autoFormApp.init();
resizeObserverApp.init();
tabsApp.init();
